// extracted by mini-css-extract-plugin
export default {"container":"t0-z"};